// composables/useDragAndDrop.js

import { ref } from "vue";

export function useDragAndDrop({ onDrop, onDragStart, onDragEnd, isValidDropTarget }) {
  const dragHelper = ref({
    letter: null,
    x: 0,
    y: 0,
    visible: false,
  });

  const handleDragStart = (event, payload) => {
    event.dataTransfer.setData("text/plain", JSON.stringify(payload));
    if (onDragStart) onDragStart(payload);

    const dragIcon = event.target.cloneNode(true);
    dragIcon.style.position = "absolute";
    dragIcon.style.top = "-1000px";
    dragIcon.style.left = "-1000px";
    document.body.appendChild(dragIcon);
    event.dataTransfer.setDragImage(dragIcon, dragIcon.offsetWidth / 2, dragIcon.offsetHeight / 2);

    event.target.addEventListener("dragend", () => {
      document.body.removeChild(dragIcon);
      if (onDragEnd) onDragEnd();
    }, { once: true });
  };

  const handleDrop = (event, dropZoneEl) => {
    const data = JSON.parse(event.dataTransfer.getData("text/plain"));
    const valid = isValidDropTarget ? isValidDropTarget(data, dropZoneEl) : true;

    if (onDrop) onDrop({ data, valid });
  };

  // Touch support
  const handleTouchStart = (event, payload) => {
    const touch = event.touches[0];
    dragHelper.value = {
      letter: payload,
      x: touch.clientX,
      y: touch.clientY,
      visible: true,
    };
    if (onDragStart) onDragStart(payload);
  };

  const handleTouchMove = (event) => {
    const touch = event.touches[0];
    dragHelper.value.x = touch.clientX;
    dragHelper.value.y = touch.clientY;
  };

  const handleTouchEnd = (event, dropZoneEl) => {
    const touch = event.changedTouches[0];
    const rect = dropZoneEl.getBoundingClientRect();

    const isInside =
      touch.clientX >= rect.left &&
      touch.clientX <= rect.right &&
      touch.clientY >= rect.top &&
      touch.clientY <= rect.bottom;

    const payload = dragHelper.value.letter;
    const valid = isInside && (!isValidDropTarget || isValidDropTarget(payload, dropZoneEl));

    if (onDrop) onDrop({ data: payload, valid });

    dragHelper.value = {
      letter: null,
      x: 0,
      y: 0,
      visible: false,
    };

    if (onDragEnd) onDragEnd();
  };

  return {
    dragHelper,
    handleDragStart,
    handleDrop,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
  };
}
